const PRICING_CONFIG = {
  ad: {
    base: 9,
    tiers: [
      { upTo: 100, rate: 0 },
      { upTo: 1000, rate: 0.05 },
      { upTo: 5000, rate: 0.03 },
    ],
  },
  full: {
    base: 29,
    tiers: [
      { upTo: 100, rate: 0 },
      { upTo: 1000, rate: 0.20 },
      { upTo: 5000, rate: 0.15 },
    ],
  },
};

export function calculatePrice(tier, domainCount) {
  const config = PRICING_CONFIG[tier] || PRICING_CONFIG.ad;
  let total = config.base;

  if (domainCount <= 100) return total;

  let prevLimit = 100;
  for (const t of config.tiers) {
    if (t.upTo <= 100) continue;
    const domainsInTier = Math.min(domainCount, t.upTo) - prevLimit;
    if (domainsInTier > 0) {
      total += domainsInTier * t.rate;
    }
    prevLimit = t.upTo;
    if (domainCount <= t.upTo) break;
  }

  return Math.round(total * 100) / 100;
}

export const MAX_SLIDER_DOMAINS = 5000;
export const MIN_SLIDER_DOMAINS = 100;
export const SLIDER_STEP = 100;
